<template>
  <div class="flex w-full items-center p-s md:p-l gap-l rounded-2xl bg-surface-primary transition-all duration-300 ease-in-out">
    <div class="flex-1 flex flex-col gap-3xs">
      <div class="flex flex-col gap-3xs items-start self-stretch">
        <Skeleton class="h-4 w-1/5" />
        <Skeleton class="h-4 w-1/2" />
      </div>
      <div class="flex flex-col gap-s">
        <div class="flex flex-col gap-3xs mt-s">
          <Skeleton class="h-1 w-1/2" />
          <Skeleton class="h-1 w-full" />
          <Skeleton class="h-1 w-4/5" />
        </div>
        <div class="flex gap-2xs items-center">
          <Skeleton class="h-5 w-8" />
          <Divider orientation="vertical" class="mx-s" />
          <Skeleton class="h-5 w-15" />
          <Divider orientation="vertical" class="mx-s" />
          <Skeleton class="h-5 w-24" />
        </div>
      </div>
    </div>

    <div class="hidden lg:flex min-w-[70px] h-24 bg-surface-secondary rounded-lg shadow-xs transition-bg duration-300 ease-in-out">
      <Skeleton class="w-full h-full" />
    </div>
  </div>
</template>
